module.exports = __webpack_public_path__ + "static/media/discord.16671f8c.svg";